import { FastCalculator } from "@tm/data"
import { Box, TriStateSwitch } from "@tm/components"
import { handleInputSubmit } from "../../../business"
import { useStoreContext } from "../../../state"

type Props = {
    item: FastCalculator.CalcInput
    disableTitleLabel?: boolean
    onChangeCallBack?: (data: any) => void
    fromWidget?: boolean
}

export function CalcInputCheck(props: Props) {
    const { item, disableTitleLabel, onChangeCallBack, fromWidget } = props
    const instance = useStoreContext()
    const switchStatus = item.value

    function handleChange() {
        !fromWidget && handleInputSubmit(instance, { ...item, value: !item.value })
        onChangeCallBack?.(!item.value)
    }

    return (
        <Box>
            <TriStateSwitch label={item.label || (disableTitleLabel ? "" : item.title)} value={switchStatus} onToggle={handleChange} />
        </Box>
    )
}

export default CalcInputCheck
